import { useTranslation } from "react-i18next";
import {
  GoMakeDialog,
  GomakeOutlinedTextInput,
  LazyRenderList,
  ThreeOptionsModal,
} from "@/components";
import { Stack } from "@mui/material";
import { ModalType } from "@/enums";
import { useIsMobile } from "@/hooks/use-responsive";

const PrintPackingSlipModal = ({
  openPackagesModal,
  onClosePackagesModal,
  renderPackageInput,
  quantityOfPackages,
  quantityPerPackage,
  handleQuantityOfPackagesChange,
  handleQuantityPerPackageChange,
  onClickConfirm,
  openPrintExportModal,
  setOpenPrintExportModal,
  exportPdf,
  printPackingSlip,
  isPrintHouseUsePrintNode,
}: any) => {
  // Note: prop name kept as isPrintHouseUsePrintNode for backward compatibility, but it now receives isPrintHouseHasPackagingSlipPrinter value
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  return (
    <>
      <GoMakeDialog
        open={openPackagesModal}
        onClose={onClosePackagesModal}
        title={t("boardMissions.packagesTitle")}
        primaryButtonLabel={t("modal.confirm")}
        cancelButtonLabel={t("modal.cancel")}
        onPrimaryAction={onClickConfirm}
        onCancel={onClosePackagesModal}
        maxWidth="sm"
        fullWidth
        sx={{ zIndex: 999999 }}
        customStyles={{
          paper: {
            maxWidth: isMobile ? "90vw" : 600,
          },
        }}
      >
        <Stack direction={"column"} gap={"15px"} paddingTop={"16px"}>
          <Stack direction={"row"} gap={"15px"}>
            <div style={{ width: "40%" }}>
              <GomakeOutlinedTextInput
                label={t("boardMissions.quantityOfPackages")}
                value={quantityOfPackages}
                onChange={handleQuantityOfPackagesChange}
                type="number"
                inputHeight={40}
              />
            </div>
            <div style={{ width: "40%" }}>
              <GomakeOutlinedTextInput
                label={t("boardMissions.quantityPerPackage")}
                value={quantityPerPackage}
                onChange={handleQuantityPerPackageChange}
                type="number"
                inputHeight={40}
              />
            </div>
          </Stack>
          <LazyRenderList
            itemCount={
              quantityOfPackages && quantityOfPackages > 0
                ? quantityOfPackages
                : 0
            }
            renderItem={renderPackageInput}
            batchSize={60}
            maxHeight={400}
            innerStyle={{
              flexDirection: "row",
              flexWrap: "wrap",
            }}
          />
        </Stack>
      </GoMakeDialog>

      {isPrintHouseUsePrintNode && (
        <ThreeOptionsModal
          modalType={ModalType.WARNING}
          title="boardMissions.selectPackingSlipAction"
          subTitle="boardMissions.selectPackingSlipActionSubtitle"
          yesBtn="boardMissions.exportPdf"
          noBtn="boardMissions.print"
          openModal={openPrintExportModal}
          onClose={() => setOpenPrintExportModal(false)}
          onClickYes={() => {
            setOpenPrintExportModal(false);
            exportPdf();
          }}
          onClickNo={() => {
            setOpenPrintExportModal(false);
            printPackingSlip();
          }}
          style={
            isMobile
              ? {
                width: "95vw",
                maxWidth: 600,
                minWidth: "unset",
              }
              : undefined
          }
        />
      )}
    </>
  );
};

export { PrintPackingSlipModal };
